module.exports = __webpack_public_path__ + "static/media/crowdsegment-logo-round-edges.e6143bd8.png";